import React, { useState, useEffect } from 'react';

export default function CountdownTimer({ targetTime, intervalMinutes }) {
  const [remaining, setRemaining] = useState('');

  useEffect(() => {
    if (!targetTime) { setRemaining('--:--'); return; }

    const update = () => {
      const now = new Date();
      const ts = typeof targetTime === 'string' && !targetTime.endsWith('Z') ? targetTime + 'Z' : targetTime;
      let target = new Date(ts);

      if (intervalMinutes && target <= now) {
        const intervalMs = intervalMinutes * 60 * 1000;
        while (target <= now) {
          target = new Date(target.getTime() + intervalMs);
        }
      }

      const diff = Math.max(0, Math.floor((target - now) / 1000));

      if (diff === 0) {
        setRemaining('Due');
        return;
      }

      const mins = Math.floor(diff / 60);
      const secs = diff % 60;
      setRemaining(`${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`);
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [targetTime, intervalMinutes]);

  return <span className="queue-countdown">{remaining}</span>;
}
